// extracted by mini-css-extract-plugin
module.exports = {"appreciation_day":"AppreciationDay_appreciation_day__HDlww"};